<div cdkDrag class="agent-container" [class.expanded]="!isBigbeeHomePage && isExpanded" [class.on-community]="isCommunityPage"
  *ngIf="!isBigbeeHomePage && canShowAgent" [cdkDragDisabled]="isExpanded" [ngClass]="{ 'reset-position': isExpanded }"
  [ngStyle]="{'box-shadow': '0px 2px 5px '+ settingsData?.ai_agent_text_color,'border-radius':'50px' }">

  <!-- Collapsed bubble -->
  <div cdkDragHandle class="agent-header agent-closed"
    *ngIf="!isBigbeeHomePage && !isExpanded && canShowAgent && isAgentEnabled" (click)="toggleChat()"
    [matTooltip]="displayAgentName ? ('Ask ' + displayAgentName) : (channelDisplayName ? channelDisplayName + ' Agent Support' : (clientDetails?.ai_assistant?.assistant_name || 'AI Agent Support'))"
    [ngStyle]="{ 'background-color': settingsData?.ai_agent_bg_color }">
    <span class="material-icons fs-32" [ngStyle]="{ 'color': settingsData?.ai_agent_text_color }">support_agent</span>
  </div>

  <!-- Expanded: fa-layout design -->
  <div class="agent-content" *ngIf="!isBigbeeHomePage && isExpanded && canShowAgent">
    <div class="fa-layout" [ngStyle]="{'background-color': settingsData?.ai_agent_bg_color ? settingsData.ai_agent_bg_color : null}" [class.hub-collapsed]="!isHubOpen" [class.nav-collapsed]="!isNavOpen">

      <!-- ── LEFT: Navigation Menu ── -->
      <div class="fa-nav-panel" [class.fa-nav-panel--collapsed]="!isNavOpen">
        <div class="fa-nav-header">
          <div class="fa-nav-logo" [class.fa-nav-logo--collapsed]="!isNavOpen">
            <img [src]="getNavLogo()" alt="logo" class="fa-nav-logo-img" appLogoTile />
          </div>
          <button class="fa-nav-toggle-btn" (click)="toggleNav()" [matTooltip]="isNavOpen ? 'Collapse menu' : 'Expand menu'">
            <span class="material-icons">{{ isNavOpen ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right' }}</span>
          </button>
        </div>
        <nav class="fa-nav-list">
          <div *ngFor="let item of visibleNavItems"
            class="fa-nav-item"
            [class.fa-nav-item--active]="isNavItemActive(item)"
            (click)="onNavItemClick(item)">
            <span class="material-icons fa-nav-icon">{{ item.icon }}</span>
            <span class="fa-nav-label" *ngIf="isNavOpen">{{ getNavLabel(item) }}</span>
          </div>
        </nav>
      </div>

      <!-- ── CENTER: top bar / scroll area / ask bar (specs/ai-agent-home-redesign) ── -->
      <div class="fa-main">

        <app-agent-top-bar
          [networkName]="networkName"
          [groups]="sortedGroups"
          [currentGroupSlug]="currentGroupSlug"
          [currentGroupName]="currentGroupName"
          [showGroups]="showGroupsRow"
          [isHubOpen]="isHubOpen"
          (groupSelected)="onScopeSelected($event)"
          (toggleHub)="toggleHub()"
          (minimize)="toggleChat()">
        </app-agent-top-bar>

        <div class="fa-content-area" #messagesContainer (scroll)="onScroll($event)">
          <div class="fa-home">

            <div class="fa-welcome">
              <h1 class="fa-banner-title">Welcome back, <span>{{ fanName }}</span> 👋</h1>
              <p class="fa-banner-sub">{{ welcomeSubtitle }}</p>
            </div>

            <!-- "For You" tab row hidden (US-3, Oct 27 2026); kept for when more tabs are added.
            <div class="fa-tabbar" role="tablist">
              <button type="button" class="fa-tab fa-tab--active" role="tab" aria-selected="true">For You</button>
            </div>
            -->

            <!-- Grouping Questions in center (unchanged) -->
            <!-- Center Event Carousel -->
            <div class="fa-center-carousel" *ngIf="nextHubEvents.length > 0" [ngStyle]="carouselColorVars">
              <div class="fa-cc-track">
                <div class="fa-cc-slide"
                     *ngFor="let event of nextHubEvents; let i = index"
                     [class.fa-cc-slide--active]="i === centerCarouselIndex">
                  <img *ngIf="event.teamLogo" class="fa-cc-bg-img" [src]="event.teamLogo" alt="" />
                  <div class="fa-cc-overlay"></div>

                  <!-- Top-left corner tag, as in the original design — kept out of the
                       bottom bar so it doesn't move with name/description/meta. -->
                  <span class="fa-cc-badge text-uppercase" [ngStyle]="accentBadgeStyle">
                    <span class="material-icons">auto_awesome</span>
                    {{ event.isLive ? 'LIVE NOW' : 'UPCOMING EVENT' }}
                  </span>

                  <div class="fa-cc-content">

                    <!-- Single horizontal bottom bar: name / description / meta on the
                         left, countdown in the middle, CTA on the right — all bottom-
                         aligned along one line instead of stacked across the card's
                         height. -->
                    <div class="fa-cc-bottom-bar">

                      <div class="fa-cc-info">
                        <h2 class="fa-cc-title line-clamp line-clamp-1 text-uppercase" [title]="event.title">{{ event.title }}</h2>
                        <p class="fa-cc-description line-clamp line-clamp-1" *ngIf="event.description" [innerHTML]="event.description"></p>
                        <div class="fa-cc-meta">
                          <!-- event.date/time are blank when the source data has no parseable
                               start date at all (not a frontend bug - see parseEventDate) -
                               hide the row rather than show a bare icon and "|" with nothing
                               between them. -->
                          <span class="fa-cc-meta-item" *ngIf="event.date || event.time">
                            <span class="material-icons">event</span>
                            {{ event.date }} <span class="plr-5"> | </span>{{ event.time }}
                          </span>
                          <span class="fa-cc-meta-item" *ngIf="event.location">
                            <span class="material-icons">location_on</span>
                            {{ event.location }}
                          </span>
                          <!-- Team names + Division/Sport merged into one row (was 2 separate
                               rows) — with match_info now actually populated, 2 extra rows on
                               top of date/time + location overflowed this card's fixed height
                               and pushed the countdown timer past the bottom edge. -->
                          <span class="fa-cc-meta-item" *ngIf="event.homeTeamName || event.awayTeamName || event.divisionName || event.sportName">
                            <!-- Team images intentionally not shown for now — names only. -->
                            <span class="material-icons" *ngIf="event.homeTeamName || event.awayTeamName">sports</span>
                            <span class="fa-cc-team-names" *ngIf="event.homeTeamName || event.awayTeamName">{{ event.homeTeamName }}<span *ngIf="event.homeTeamName && event.awayTeamName"> vs </span>{{ event.awayTeamName }}</span>
                            <!-- <span *ngIf="(event.homeTeamName || event.awayTeamName) && (event.divisionName || event.sportName)"> </span> -->
                            | <span class="material-icons" *ngIf="event.divisionName || event.sportName">sports_score</span>
                            <span *ngIf="event.divisionName || event.sportName">{{ event.divisionName }}<span *ngIf="event.divisionName && event.sportName"> &middot; </span>{{ event.sportName }}</span>
                          </span>
                        </div>
                      </div>

                      <!-- Also requires event.eventDate: without a real start date there's
                           nothing to count down to, and the countdown would otherwise sit
                           frozen at 00:00:00:00 forever instead of just not rendering. -->
                      <div class="fa-cc-countdown" *ngIf="!event.isLive && event.eventDate">
                        <span class="fa-cc-countdown-label text-uppercase">EVENT STARTS IN</span>
                        <div class="fa-cc-countdown-row">
                          <div class="fa-cc-count-box">
                            <span class="fa-cc-count-num">{{ event.days }}</span>
                            <span class="fa-cc-count-lbl text-uppercase">DAYS</span>
                          </div>
                          <div class="fa-cc-count-box">
                            <span class="fa-cc-count-num">{{ event.hrs }}</span>
                            <span class="fa-cc-count-lbl text-uppercase">HRS</span>
                          </div>
                          <div class="fa-cc-count-box">
                            <span class="fa-cc-count-num">{{ event.min }}</span>
                            <span class="fa-cc-count-lbl text-uppercase">MIN</span>
                          </div>
                          <div class="fa-cc-count-box">
                            <span class="fa-cc-count-num">{{ event.sec }}</span>
                            <span class="fa-cc-count-lbl text-uppercase">SEC</span>
                          </div>
                        </div>
                      </div>

                      <div class="fa-cc-actions">
                        <button class="fa-cc-btn-primary"
                          (click)="event.isInvestment ? openUrl(event.ctaUrl) : isRemindMe(event) ? remindMe(event) : navigateToItem({badge: event.isLive ? 'LIVE' : 'UPCOMING', title: event.title, slug: event.slug, channelName: event.channelName, groupSlug: event.groupSlug, ticketKey: event.ticketKey, selectedType: event.selectedType, streamid: event.streamid})"
                          [disabled]="event.isRegistering"
                          [ngStyle]="carouselCtaStyle">
                          <span class="material-icons">{{ event.isInvestment ? event.ctaIcon : (event.isLive ? 'live_tv' : 'local_activity') }}</span>
                          {{ event.ctaLabel }}
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="fa-cc-dots" *ngIf="nextHubEvents.length > 1">
                  <span *ngFor="let e of nextHubEvents; let i = index"
                        class="fa-cc-dot pointer"
                        [class.fa-cc-dot--active]="i === centerCarouselIndex"
                        (click)="centerCarouselIndex = i"></span>
                </div>
              </div>
            </div>

            <!-- No live/upcoming events: home-page banner + Subscribe in the carousel's slot -->
            <div class="fa-empty-banner" *ngIf="!isDashboardLoading && !nextHubEvents.length && homeBannerImage"
                 [style.background-image]="'url(' + homeBannerImage + ')'">
              <button type="button" class="fa-empty-banner-btn pointer" [ngStyle]="carouselCtaStyle"
                      [disabled]="isSubscribed && userInfo?.id" (click)="goToSubscribe()">
                {{ isSubscribed && userInfo?.id ? 'Subscribed' : 'Subscribe' }}
              </button>
            </div>

            <app-agent-quick-actions
              [actions]="homeQuickActions"
              (actionSelected)="useSuggestion($event)"
              (browseEvents)="browseAllEvents()">
            </app-agent-quick-actions>

            <app-agent-recommended
              [items]="recommendedItems"
              [subtitle]="recommendedSubtitle"
              [loading]="isDashboardLoading"
              [hasPreferences]="hasPreferredChannel || groupProfileSaved"
              [reasonContext]="reasonContext"
              [badgeColor]="badgeColorFn"
              [badgeFontColor]="badgeFontColorFn"
              (itemSelected)="navigateToItem($event)"
              (whyThese)="openPreferencesDialog()">
            </app-agent-recommended>

            <app-agent-groups-bar *ngIf="showGroupsRow"
              [networkName]="networkName"
              [groupsLabel]="groupsLabel"
              [groups]="memberBarGroups"
              [currentGroupSlug]="currentGroupSlug"
              (groupSelected)="onScopeSelected($event)"
              (openAll)="openGroupsDialog()">
            </app-agent-groups-bar>

            <!-- Chat Messages -->
            <div class="fa-messages-area" *ngIf="(messagesList | async)?.length > 0" [ngStyle]="{'--fa-accent-text': accentTextColor}">
              <div class="fa-chat-divider">{{ displayAgentName ? ('Ask ' + displayAgentName) : 'Conversation' }}</div>
              <div *ngFor="let msg of messagesList | async; trackBy: trackByIndex" class="fa-msg"
                [class.fa-msg-user]="msg.sender === 'user'"
                [class.fa-msg-bot]="msg.sender === 'bot'">

                <!-- Typing / loading spinner -->
                <div *ngIf="msg.isStreaming && !msg.message" class="fa-typing">
                  <span></span><span></span><span></span>
                </div>

                <!-- Message bubble -->
                <ng-container *ngIf="!msg.isStreaming || msg.message">
                  <!-- User message -->
                  <div *ngIf="msg.sender === 'user'" class="fa-msg-bubble"
                    [ngStyle]="{'background-color': accentColor, 'color': accentTextColor}">
                    <div *ngIf="msg.files?.length" class="fa-msg-files">
                      <ng-container *ngFor="let f of msg.files">
                        <img *ngIf="f.type === 'image'" [src]="f.url" class="fa-msg-img" alt="" (click)="downloadFile(f)"
                          title="Click to download">
                        <div *ngIf="f.type !== 'image'" class="fa-msg-file-chip" (click)="downloadFile(f)">
                          <span class="material-icons">{{ getFileIcon(f.type) }}</span>
                          <span>{{ f.name }}</span>
                        </div>
                      </ng-container>
                    </div>
                    <span *ngIf="msg.message">{{ msg.message }}</span>
                  </div>

                  <!-- Bot message -->
                  <ng-container *ngIf="msg.sender === 'bot'">
                    <div class="fa-msg-bubble fa-msg-bubble--html Message-loading" [class.streaming]="msg.isStreaming">
                      <span class="circular-loading-spinner" *ngIf="msg.isStreaming"></span>
                      <div [innerHTML]="shouldTruncateMessage(msg.message) && !isMessageExpanded(msg)
                        ? getTruncatedMessage(msg.message)
                        : msg.message">
                      </div>
                    </div>

                    <button *ngIf="shouldTruncateMessage(msg.message)" class="fa-expand-btn"
                      (click)="toggleMessageExpansion(msg)" [ngStyle]="{'color': textColor}">
                      {{ isMessageExpanded(msg) ? 'Show less' : ('Show ' + getRemainingRows(msg.message) + ' more rows')
                      }}
                    </button>

                    <div *ngIf="!msg.hideActions && !msg.isStreaming && currentChatId" class="fa-feedback-row">
                      <button class="fa-feedback-btn"
                        [class.fa-feedback-active]="msg.feedback === 'like'"
                        [style.display]="msg.feedback === 'dislike' && !msg.feedbackInteracted ? 'none' : ''"
                        title="Helpful"
                        (click)="updateMessageFeedback(msg, 'like')">
                        <span class="material-icons">thumb_up</span>
                      </button>
                      <button class="fa-feedback-btn"
                        [class.fa-feedback-active]="msg.feedback === 'dislike'"
                        [style.display]="msg.feedback === 'like' && !msg.feedbackInteracted ? 'none' : ''"
                        title="Not helpful"
                        (click)="updateMessageFeedback(msg, 'dislike')">
                        <span class="material-icons">thumb_down</span>
                      </button>
                    </div>
                  </ng-container>
                </ng-container>

                <span *ngIf="msg.time && (!msg.isStreaming || msg.message)" class="fa-msg-time">{{ msg.time }}</span>
              </div>
            </div>

          </div>
        </div>

        <!-- Scroll-to-bottom arrow -->
        <button *ngIf="showScrollToBottomArrow" class="fa-scroll-arrow" (click)="scrollToBottom()"
          [ngStyle]="{'color': accentTextColor}">
          <span class="material-icons">arrow_downward</span>
        </button>

        <app-agent-ask-bar
          [agentName]="displayAgentName || ((networkName || 'Fan') + ' Agent')"
          [context]="askContext"
          [chips]="askChips"
          (chipSelected)="useSuggestion($event)">

          <div askBarTop class="fa-ask-top">
            <!-- Hidden file input -->
            <input #fileInput type="file" multiple style="display:none" (change)="onFileSelected($event)"
              accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.txt">

            <!-- File preview strip -->
            <div *ngIf="selectedFiles.length > 0" class="fa-file-strip">
              <div *ngFor="let f of selectedFiles; let i = index" class="fa-file-chip">
                <img *ngIf="f.type === 'image'" [src]="f.previewUrl" class="fa-file-thumb" alt="">
                <span *ngIf="f.type !== 'image'" class="material-icons fa-file-icon">{{ getFileIcon(f.type) }}</span>
                <span class="fa-file-name">{{ f.name }}</span>
                <button class="fa-file-remove" (click)="removeFile(i)">
                  <span class="material-icons">close</span>
                </button>
              </div>
            </div>

            <!-- Voice recording UI -->
            <div *ngIf="isRecording || audioBlob" class="fa-voice-ui">
              <ng-container *ngIf="isRecording">
                <div class="fa-voice-row">
                  <div class="fa-rec-dot"></div>
                  <div id="fa-waveform-live" class="fa-waveform"></div>
                  <button class="fa-voice-cancel" (click)="cancelRecording()" title="Cancel">
                    <span class="material-icons">cancel</span>
                  </button>
                  <button class="fa-voice-stop" (click)="confirmAndSend()" title="Stop & Transcribe">
                    <span class="material-icons">check_circle</span>
                  </button>
                </div>
              </ng-container>
              <ng-container *ngIf="!isRecording && audioBlob">
                <div class="fa-voice-row">
                  <div *ngIf="isProcessing" class="fa-spinner-sm"></div>
                  <div id="fa-waveform-frozen" class="fa-waveform"></div>
                  <button class="fa-voice-cancel" (click)="resetAudio()" title="Discard">
                    <span class="material-icons">cancel</span>
                  </button>
                </div>
              </ng-container>
            </div>

          </div>

          <div class="fa-input-row">
            <textarea #messageInput class="fa-input" [(ngModel)]="userInput" rows="1" [disabled]="chatPaused"
              [placeholder]="chatPaused ? pausedNote : ('Ask ' + (displayAgentName || ((networkName || 'Fan') + ' Agent')) + ' about events, clips, tickets, merch, teams and more...')" [ngStyle]="{'color': textColor}"
              (keydown)="onKeydown($event)" (input)="adjustTextareaHeight($event)"></textarea>
            <button class="fa-mic-btn" [class.fa-mic-active]="isRecording" (click)="toggleAudioRecording()"
              title="Voice message" [disabled]="isProcessing || chatPaused">
              <span *ngIf="!isProcessing" class="material-icons">{{ isRecording ? 'stop' : 'mic' }}</span>
              <div *ngIf="isProcessing" class="fa-spinner-sm"></div>
            </button>

            <button class="fa-send-btn" (click)="sendMessage()"
              [disabled]="isLoading || isMessageStreaming || disableSend || chatPaused"
              [ngStyle]="{'background-color': accentColor, 'color': accentTextColor}">
              <span *ngIf="!isLoading && !isMessageStreaming" class="material-icons">send</span>
              <div *ngIf="isLoading || isMessageStreaming" class="fa-spinner-sm"></div>
            </button>
          </div>
          <!-- Channel owner's AI chat is paused (credits): message box disabled for this visit. -->
          <p class="fa-paused-note" *ngIf="chatPaused" role="status">{{ pausedNote }}</p>

        </app-agent-ask-bar>

      </div>

      <!-- ── RIGHT: Fan Hub ── -->
      <aside class="fa-hub" [class.fa-hub--collapsed]="!isHubOpen">
        <ng-container *ngIf="isHubOpen">
        <app-agent-pulse-header (close)="toggleHub()"></app-agent-pulse-header>
        <div class="fa-hub-scroll">
          <app-agent-prefs-card
            [agentName]="displayAgentName"
            [preferences]="savedPreferenceNames"
            (edit)="openPreferencesDialog()">
          </app-agent-prefs-card>

          <!-- uReport news: network page = network + schools, school page = that school only -->
          <app-fan-news-card design="v2" [stories]="ureportNews" [sourceName]="currentGroupName || networkName"></app-fan-news-card>

          <app-agent-chat-history
            [agentName]="displayAgentName"
            (show)="openChatHistoryDialog()">
          </app-agent-chat-history>
        </div>
        </ng-container>

      </aside>

    </div>

    <!-- Preferences UI, rendered in the dialog opened by openPreferencesDialog() (right panel Edit, "Why these?"). -->
    <ng-template #preferencesTpl>
        <div class="fa-hero-card" [class.fa-hero-card--no-border]="currentGroupId" *ngIf="userInfo?.id">
            <div class="fa-hero-body">
              <!-- Channel Profile Selection -->

          <!-- Subchannel selection: shown ahead of Grouping Questions so channels appear first,
               with its edit/close button at the top, when both channels and category/division
               data exist together (channels + divisions & sports, no groups). Once anything has
               been saved (either side), an unpicked channels section collapses instead of always
               showing its open picker - Edit (shared, see onEditAllPreferences) brings it back. -->
          <div *ngIf="preferenceDisplayMode === 'channels' && (isEditingChannelProfile || selectedSubChannels.length > 0 || !anyPreferencesSaved)">
            <div class="fa-profile-section">
              <div class="fa-profile-section-header">
                <span class="material-icons fa-profile-section-icon"
                  [ngStyle]="{'color': accentColor}">group</span>
                <div class="fa-profile-section-header-text">
                  <span class="fa-profile-section-title" [ngStyle]="{'color': textColor}">{{org_info?.network_type}}</span>
                  <span class="fa-profile-section-title" [ngStyle]="{'color': textColor}">
                    {{ !isEditingChannelProfile && selectedSubChannels.length > 0 ? 'Your selected ' + (org_info?.network_type || 'Teams') : 'Choose the ' + (org_info?.network_type || 'Teams') + ' you want to join' }}
                  </span>
                </div>
                <button *ngIf="!isEditingChannelProfile && selectedSubChannels.length > 0"
                  class="fa-profile-edit-btn" (click)="onEditAllPreferences()"
                  [ngStyle]="{'color': accentColor, 'border-color': accentColor}">
                  <span class="material-icons">edit</span>
                  Edit
                </button>
              </div>

              <div *ngIf="!isEditingChannelProfile && selectedSubChannels.length > 0" class="fa-profile-grid">
                <button *ngFor="let channel of selectedSubChannels" class="fa-profile-item fa-profile-item--selected">
                  <img *ngIf="channel.channel_logo || channel.channel_image || channel.logo"
                    [src]="channel.channel_logo || channel.channel_image || channel.logo"
                    class="fa-profile-item-img" alt="" />
                  <span *ngIf="!channel.channel_logo && !channel.channel_image && !channel.logo"
                    class="material-icons fa-profile-item-default-icon">group</span>
                  <span class="fa-profile-item-label"
                    [matTooltip]="(channel.channel_display_name || channel.channel_name)?.length > 22 ? (channel.channel_display_name || channel.channel_name) : ''"
                    matTooltipPosition="above">{{ truncateLabel(channel.channel_display_name || channel.channel_name) }}</span>
                  <span class="material-icons fa-profile-item-check">check</span>
                </button>
              </div>

              <div *ngIf="isEditingChannelProfile || selectedSubChannels.length === 0" class="fa-profile-grid">
                <button *ngFor="let channel of subChannels" class="fa-profile-item"
                  [class.fa-profile-item--selected]="isSubChannelSelected(channel)"
                  [ngStyle]="isSubChannelSelected(channel)
                    ? {}
                    : {'color': textColor, 'border-color': getFadedColor(textColor, 0.15)}"
                        (click)="toggleSubChannelSelection(channel)">
                        <img *ngIf="channel.channel_logo || channel.channel_image || channel.logo"
                          [src]="channel.channel_logo || channel.channel_image || channel.logo" class="fa-profile-item-img" alt="" />
                        <span *ngIf="!channel.channel_logo && !channel.channel_image && !channel.logo"
                          class="material-icons fa-profile-item-default-icon">group</span>
                        <span class="fa-profile-item-label"
                          [matTooltip]="(channel.channel_display_name || channel.channel_name)?.length > 22 ? (channel.channel_display_name || channel.channel_name) : ''"
                          matTooltipPosition="above">{{ truncateLabel(channel.channel_display_name || channel.channel_name) }}</span>
                        <span *ngIf="isSubChannelSelected(channel)"
                          class="material-icons fa-profile-item-check">check</span>
                      </button>
                    </div>
                  </div>

                </div>

          <!-- Grouping Questions (always shown when data is available). Sports Divisions inside
               this wrapper must render regardless of groups-vs-channels priority, so the gate
               also opens for 'channels' mode whenever category/division data exists (case: channels + divisions & sports, no groups).
               Once anything has been saved (either side), this section collapses too if it has
               no saved data of its own - Edit (shared, see onEditAllPreferences) brings it back. -->
          <div *ngIf="(preferenceDisplayMode === 'groups' || preferenceDisplayMode === 'categories' || (preferenceDisplayMode === 'channels' && hasCategoryData)) && groupInfo?.total_questions > 0 && grouptypeSelectionQuestion && (isEditingGroupProfile || groupProfileSaved || !anyPreferencesSaved)" class="fa-profile-selection mt-15">
            <div class="fa-profile-section">
              <div class="fa-profile-section-header">
                <span class="material-icons fa-profile-section-icon" [ngStyle]="{'color': accentColor}">group</span>
                <div class="fa-profile-section-header-text">
                  <span *ngIf="!groupProfileSaved || isEditingGroupProfile" class="fa-profile-section-title" [ngStyle]="{'color': textColor}">{{ grouptypeSelectionQuestion.question }}</span>
                  <span class="fa-profile-section-title" [ngStyle]="{'color': textColor}">
                    {{ groupProfileSaved && !isEditingGroupProfile ? 'Your saved preferences' : (grouptypeSelectionQuestion.description || 'Choose your preferences') }}
                  </span>
                </div>
                <button *ngIf="groupProfileSaved && !isEditingGroupProfile && !(preferenceDisplayMode === 'channels' && selectedSubChannels.length > 0)"
                  class="fa-profile-edit-btn" (click)="onEditAllPreferences()"
                  [ngStyle]="{'color': accentColor, 'border-color': accentColor}">
                  <span class="material-icons">edit</span>
                  Edit
                </button>
              </div>

              <!-- Saved state: read-only highlighted tiles. A saved Group whose partner has
                   hidden it from the network (is_active=false) stays listed here - never
                   removed - but greyed out and non-interactive, and automatically returns to
                   its normal active state the moment the partner makes it visible again. -->
              <div *ngIf="groupProfileSaved && !isEditingGroupProfile" class="fa-profile-grid">
                <button *ngFor="let item of savedGroupItems"
                  class="fa-profile-item fa-profile-item--selected"
                  [class.fa-profile-item--inactive]="item.is_active === false"
                  [disabled]="item.is_active === false"
                  [attr.aria-disabled]="item.is_active === false"
                  [matTooltip]="item.is_active === false ? 'Currently hidden by the partner - saved, not selectable' : (item.name?.length > 22 ? item.name : '')"
                  matTooltipPosition="above">
                  <div class="fa-hub-pref-team-logo" *ngIf="item.logo"><img [src]="item.logo" class="fa-hub-pref-chip-logo" alt="" /></div>
                  <span class="fa-profile-item-label">{{ truncateLabel(item.name) }}</span>
                  <span *ngIf="item.is_active === false" class="material-icons fa-profile-item-check">visibility_off</span>
                  <span *ngIf="item.is_active !== false" class="material-icons fa-profile-item-check">check</span>
                </button>
              </div>

              <!-- Edit / initial state: full interactive grid -->
              <ng-container *ngIf="!groupProfileSaved || isEditingGroupProfile">

                <!-- 1. Your Interests -->
                <ng-container *ngIf="preferenceDisplayMode === 'groups' && grouptypeSelectionQuestion.group_type_options?.length">
                  <p class="fa-grouping-sublabel">Your Interests:</p>
                  <div class="fa-profile-grid">
                    <button *ngFor="let opt of grouptypeSelectionQuestion.group_type_options"
                      class="fa-profile-item"
                      [class.fa-profile-item--selected]="isHeroGroupTypeSelected(opt.value)"
                      [ngStyle]="isHeroGroupTypeSelected(opt.value)
                        ? {}
                        : {'color': textColor, 'border-color': getFadedColor(textColor, 0.15)}"
                      (click)="toggleHeroGroupType(opt.value)">
                      <span class="fa-profile-item-label"
                        [matTooltip]="opt.label?.length > 22 ? opt.label : ''"
                        matTooltipPosition="above">{{ truncateLabel(opt.label) }} ({{ opt.count }})</span>
                      <span *ngIf="isHeroGroupTypeSelected(opt.value)" class="material-icons fa-profile-item-check">check</span>
                    </button>
                  </div>
                </ng-container>

                <!-- 2. Questions related to selected interests (type === 'group') -->
                <ng-container *ngIf="preferenceDisplayMode === 'groups'">
                <ng-container *ngFor="let question of visibleHeroPreferenceQuestions; trackBy: trackByQIndex">
                  <ng-container *ngIf="question.type === 'group' && question.options?.length">
                    <p class="fa-grouping-sublabel">{{ question.question }}</p>
                    <div class="fa-profile-grid">
                      <button *ngFor="let opt of question.options"
                        class="fa-profile-item"
                        [class.fa-profile-item--selected]="isHeroPreferenceSelected(question._qIndex, '' + opt.id)"
                        [ngStyle]="isHeroPreferenceSelected(question._qIndex, '' + opt.id)
                          ? {'background-color': accentColor, 'color': accentTextColor, 'border-color': accentColor}
                          : {'color': textColor, 'border-color': getFadedColor(textColor, 0.15)}"
                        (click)="toggleHeroPreference(question._qIndex, '' + opt.id)">
                                          <div class="fa-hub-pref-team-logo" *ngIf="opt.logo"><img [src]="opt.logo" class="fa-hub-pref-chip-logo" alt="" /></div>
                        <span class="fa-profile-item-label"
                          [matTooltip]="opt.name?.length > 22 ? opt.name : ''"
                          matTooltipPosition="above">{{ truncateLabel(opt.name) }}</span>
                        <span *ngIf="isHeroPreferenceSelected(question._qIndex, '' + opt.id)" class="material-icons fa-profile-item-check">check</span>
                      </button>
                    </div>
                  </ng-container>
                </ng-container>
                </ng-container>

                <!-- 3. Sports Divisions -->
                <ng-container *ngIf="hasCategoryData">
                <ng-container *ngIf="visibleDivisionOptions.length">
                  <p class="fa-grouping-sublabel">Sports Divisions:</p>
                  <div class="fa-profile-grid">
                    <button *ngFor="let opt of visibleDivisionOptions"
                      class="fa-profile-item"
                      [class.fa-profile-item--selected]="isHeroGroupDivisionSelected(opt.division_id)"
                      [ngStyle]="isHeroGroupDivisionSelected(opt.division_id)
                        ? {}
                        : {'color': textColor, 'border-color': getFadedColor(textColor, 0.15)}"
                      (click)="toggleHeroGroupDivision(opt.division_id)">
                      <span class="fa-profile-item-label"
                        [matTooltip]="opt.label?.length > 22 ? opt.label : ''"
                        matTooltipPosition="above">{{ truncateLabel(opt.label) }}</span>
                      <span *ngIf="isHeroGroupDivisionSelected(opt.division_id)" class="material-icons fa-profile-item-check">check</span>
                    </button>
                  </div>
                </ng-container>

                <!-- 4. Questions related to selected sports (type === 'division_sports') -->
                <ng-container *ngFor="let question of visibleHeroPreferenceQuestions; trackBy: trackByQIndex">
                  <ng-container *ngIf="question.type === 'division_sports' && getVisibleSportOptions(question).length">
                    <p class="fa-grouping-sublabel">{{ question.question }}</p>
                    <div class="fa-profile-grid">
                      <button *ngFor="let opt of getVisibleSportOptions(question)"
                        class="fa-profile-item"
                        [class.fa-profile-item--selected]="isHeroPreferenceSelected(question._qIndex, opt.sport_id + '-' + opt.division_id)"
                        [ngStyle]="isHeroPreferenceSelected(question._qIndex, opt.sport_id + '-' + opt.division_id)
                          ? {'background-color': accentColor, 'color': accentTextColor, 'border-color': accentColor}
                          : {'color': textColor || '#000', 'border-color': getFadedColor(textColor || '#000', 0.15)}"
                        (click)="toggleHeroPreference(question._qIndex, opt.sport_id + '-' + opt.division_id)">
                        <span class="fa-profile-item-label">{{ opt.sport_name }}</span>
                        <span *ngIf="isHeroPreferenceSelected(question._qIndex, opt.sport_id + '-' + opt.division_id)" class="material-icons fa-profile-item-check">check</span>
                      </button>
                    </div>
                  </ng-container>
                </ng-container>
                </ng-container>

                <!-- 5. Event category questions (type === 'category') - options narrowed by
                     filterOptionsByCurrentGroup to whichever group(s) are currently checked -->
                <ng-container *ngFor="let question of visibleHeroPreferenceQuestions; trackBy: trackByQIndex">
                  <ng-container *ngIf="question.type === 'category' && filterOptionsByCurrentGroup(question.options).length">
                    <p class="fa-grouping-sublabel">{{ question.question }}</p>
                    <div class="fa-profile-grid">
                      <button *ngFor="let opt of filterOptionsByCurrentGroup(question.options)"
                        class="fa-profile-item"
                        [class.fa-profile-item--selected]="isHeroPreferenceSelected(question._qIndex, '' + opt.category_id)"
                        [ngStyle]="isHeroPreferenceSelected(question._qIndex, '' + opt.category_id)
                          ? {'background-color': accentColor, 'color': accentTextColor, 'border-color': accentColor}
                          : {'color': textColor || '#000', 'border-color': getFadedColor(textColor || '#000', 0.15)}"
                        (click)="toggleHeroPreference(question._qIndex, '' + opt.category_id)">
                        <span class="fa-profile-item-label"
                          [matTooltip]="opt.category_name?.length > 22 ? opt.category_name : ''"
                          matTooltipPosition="above">{{ truncateLabel(opt.category_name) }}</span>
                        <span *ngIf="isHeroPreferenceSelected(question._qIndex, '' + opt.category_id)" class="material-icons fa-profile-item-check">check</span>
                      </button>
                    </div>
                  </ng-container>
                </ng-container>

                <!-- 6. Event type questions (type === 'event_type'), one question per category -
                     options narrowed by filterOptionsByCurrentGroup -->
                <ng-container *ngFor="let question of visibleHeroPreferenceQuestions; trackBy: trackByQIndex">
                  <ng-container *ngIf="question.type === 'event_type' && filterOptionsByCurrentGroup(question.options).length">
                    <p class="fa-grouping-sublabel">{{ question.question }}</p>
                    <div class="fa-profile-grid">
                      <button *ngFor="let opt of filterOptionsByCurrentGroup(question.options)"
                        class="fa-profile-item"
                        [class.fa-profile-item--selected]="isHeroPreferenceSelected(question._qIndex, question.category_id + '::' + opt.event_type)"
                        [ngStyle]="isHeroPreferenceSelected(question._qIndex, question.category_id + '::' + opt.event_type)
                          ? {'background-color': accentColor, 'color': accentTextColor, 'border-color': accentColor}
                          : {'color': textColor || '#000', 'border-color': getFadedColor(textColor || '#000', 0.15)}"
                        (click)="toggleHeroPreference(question._qIndex, question.category_id + '::' + opt.event_type)">
                        <span class="fa-profile-item-label"
                          [matTooltip]="opt.event_type?.length > 22 ? opt.event_type : ''"
                          matTooltipPosition="above">{{ truncateLabel(opt.event_type) }}</span>
                        <span *ngIf="isHeroPreferenceSelected(question._qIndex, question.category_id + '::' + opt.event_type)" class="material-icons fa-profile-item-check">check</span>
                      </button>
                    </div>
                  </ng-container>
                </ng-container>

                <!-- 7. Genre questions (type === 'genre') - options narrowed by
                     filterOptionsByCurrentGroup in strict mode: each facet (group/division/sport)
                     exclusively narrows as the fan picks more, instead of the additive rule
                     category/event_type/event_tag use (see design.md Mechanism 2 Amendment) -->
                <ng-container *ngFor="let question of visibleHeroPreferenceQuestions; trackBy: trackByQIndex">
                  <ng-container *ngIf="question.type === 'genre' && filterOptionsByCurrentGroup(question.options, true).length">
                    <p class="fa-grouping-sublabel">{{ question.question }}</p>
                    <div class="fa-profile-grid">
                      <button *ngFor="let opt of filterOptionsByCurrentGroup(question.options, true)"
                        class="fa-profile-item"
                        [class.fa-profile-item--selected]="isHeroPreferenceSelected(question._qIndex, '' + opt.tag_id)"
                        [ngStyle]="isHeroPreferenceSelected(question._qIndex, '' + opt.tag_id)
                          ? {'background-color': accentColor, 'color': accentTextColor, 'border-color': accentColor}
                          : {'color': textColor || '#000', 'border-color': getFadedColor(textColor || '#000', 0.15)}"
                        (click)="toggleHeroPreference(question._qIndex, '' + opt.tag_id)">
                        <span class="fa-profile-item-label"
                          [matTooltip]="opt.name?.length > 22 ? opt.name : ''"
                          matTooltipPosition="above">{{ truncateLabel(opt.name) }}</span>
                        <span *ngIf="isHeroPreferenceSelected(question._qIndex, '' + opt.tag_id)" class="material-icons fa-profile-item-check">check</span>
                      </button>
                    </div>
                  </ng-container>
                </ng-container>

                <!-- 8. Event tag questions (type === 'event_tag') - options narrowed by
                     filterOptionsByCurrentGroup, same rule as category/event_type/genre -->
                <ng-container *ngFor="let question of visibleHeroPreferenceQuestions; trackBy: trackByQIndex">
                  <ng-container *ngIf="question.type === 'event_tag' && filterOptionsByCurrentGroup(question.options).length">
                    <p class="fa-grouping-sublabel">{{ question.question }}</p>
                    <div class="fa-profile-grid">
                      <button *ngFor="let opt of filterOptionsByCurrentGroup(question.options)"
                        class="fa-profile-item"
                        [class.fa-profile-item--selected]="isHeroPreferenceSelected(question._qIndex, eventTagKey(opt))"
                        [ngStyle]="isHeroPreferenceSelected(question._qIndex, eventTagKey(opt))
                          ? {'background-color': accentColor, 'color': accentTextColor, 'border-color': accentColor}
                          : {'color': textColor || '#000', 'border-color': getFadedColor(textColor || '#000', 0.15)}"
                        (click)="toggleHeroPreference(question._qIndex, eventTagKey(opt))">
                        <span class="fa-profile-item-label"
                          [matTooltip]="opt.tag_name?.length > 22 ? opt.tag_name : ''"
                          matTooltipPosition="above">{{ truncateLabel(opt.tag_name) }}</span>
                        <span *ngIf="isHeroPreferenceSelected(question._qIndex, eventTagKey(opt))" class="material-icons fa-profile-item-check">check</span>
                      </button>
                    </div>
                  </ng-container>
                </ng-container>

                <!-- 9. Merch tag questions (type === 'merch_tag') - partner-service data is
                     organization-wide only, so no filterOptionsByCurrentGroup narrowing here
                     (unlike category/event_type/genre/event_tag). -->
                <ng-container *ngFor="let question of visibleHeroPreferenceQuestions; trackBy: trackByQIndex">
                  <ng-container *ngIf="question.type === 'merch_tag'">
                    <p class="fa-grouping-sublabel">
                      {{ question.question }}
                      <span *ngIf="merchTagOptionsLoading" class="fa-spinner-sm"></span>
                    </p>
                    <div class="fa-profile-grid">
                      <button *ngFor="let opt of question.options"
                        class="fa-profile-item"
                        [class.fa-profile-item--selected]="isHeroPreferenceSelected(question._qIndex, opt.tag_value)"
                        [ngStyle]="isHeroPreferenceSelected(question._qIndex, opt.tag_value)
                          ? {'background-color': accentColor, 'color': settingsData?.ai_agent_bg_color || '#000', 'border-color': accentColor}
                          : {'color': textColor, 'border-color': getFadedColor(textColor, 0.15)}"
                        (click)="toggleHeroPreference(question._qIndex, opt.tag_value)">
                        <span class="fa-profile-item-label"
                          [matTooltip]="opt.tag_value?.length > 22 ? opt.tag_value : ''"
                          matTooltipPosition="above">{{ truncateLabel(opt.tag_value) }}</span>
                        <span *ngIf="isHeroPreferenceSelected(question._qIndex, opt.tag_value)" class="material-icons fa-profile-item-check">check</span>
                      </button>
                    </div>
                  </ng-container>
                </ng-container>

              </ng-container>
            </div>

            <!-- Save/Update button: only shown when editing or not yet saved, and only when the
                 combined save button below isn't already covering the groups/divisions axis
                 (isGroupsSectionEditable) - otherwise both would render at once, e.g. once a
                 group and an event type are both selected. -->
            <ng-container *ngIf="!isGroupsSectionEditable && (!groupProfileSaved || isEditingGroupProfile) && (heroGroupTypeSelections.length > 0 || heroGroupDivisionSelections.length > 0 || hasAnyEventCategorySelection)">
              <div class="fa-pref-actions">
                <button type="button" class="fa-pref-cancel-btn" (click)="closePreferencesDialog()">Cancel</button>
                <button class="fa-save-profile-btn" (click)="saveHeroGroupingPreferences()"
                  [disabled]="isSavingHeroGroupPreferences"
                  [ngStyle]="{'background-color': accentColor, 'color': accentTextColor}">
                  <span *ngIf="!isSavingHeroGroupPreferences" class="material-icons">auto_awesome</span>
                  <span *ngIf="!isSavingHeroGroupPreferences">{{ groupProfileSaved ? 'Update my preferences' : 'Save my preferences' }}</span>
                  <div *ngIf="isSavingHeroGroupPreferences" class="fa-spinner-sm"></div>
                </button>
              </div>
              <p class="fa-save-note mt-10 mb-0" [ngStyle]="{'color': textColor || '#000'}">🔒 You can update these anytime.</p>
            </ng-container>
          </div>

          <!-- Single combined save button for channels + groups/divisions, so selections in
               either section are saved together with one action instead of two separate buttons. -->
          <ng-container *ngIf="showCombinedPreferencesSave">
            <div class="fa-pref-actions">
              <button type="button" class="fa-pref-cancel-btn" (click)="closePreferencesDialog()">Cancel</button>
              <button class="fa-save-profile-btn" (click)="saveAllPreferences()"
                [disabled]="isSavingCombinedPreferences || combinedPreferencesSaveDisabled"
                [ngStyle]="{'background-color': accentColor, 'color': accentTextColor}">
                <span *ngIf="!isSavingCombinedPreferences" class="material-icons">auto_awesome</span>
                <span *ngIf="!isSavingCombinedPreferences">{{ (groupProfileSaved || channelProfileSaved) ? 'Update my preferences' : 'Save my preferences' }}</span>
                <div *ngIf="isSavingCombinedPreferences" class="fa-spinner-sm"></div>
              </button>
            </div>
            <p class="fa-save-note mt-10 mb-0" [ngStyle]="{'color': textColor || '#000'}">🔒 You can update these anytime.</p>
          </ng-container>

                <div *ngIf="isDashboardLoading" class="fa-tags-loading">
                  <div class="fa-spinner-sm"></div>
                </div>
              </div>
            </div>
    </ng-template>

    <!-- Chat history pop-up, opened by the right panel card's Show (openChatHistoryDialog, US-18). -->
    <ng-template #chatHistoryDialogTpl>
      <app-agent-chat-history-dialog
        [agentName]="displayAgentName"
        [chats]="chatHistories"
        [currentChatId]="currentChatId"
        [loading]="isLoadingHistory"
        (openChat)="loadChatHistory($event); closeChatHistoryDialog()"
        (deleteChat)="deleteChatHistory($event.chat.dynamo_id, $event.event)"
        (deleteAll)="deleteAllChatHistories($event)"
        (newChat)="createNewChat(); closeChatHistoryDialog()"
        (close)="closeChatHistoryDialog()">
      </app-agent-chat-history-dialog>
    </ng-template>

    <ng-template #preferencesDialogTpl>
      <div class="fa-pref-dialog">
        <div class="fa-pref-dialog-top">
          <h2>Make this your fan network</h2>
          <button type="button" class="fa-pref-dialog-close" (click)="closePreferencesDialog()" aria-label="Close dialog">
            <span class="material-icons">close</span>
          </button>
        </div>
        <p class="fa-pref-dialog-desc">Choose what you follow. Your feed, recommendations and {{ displayAgentName || 'agent' }} reflect these choices.</p>
        <ng-container *ngTemplateOutlet="preferencesTpl"></ng-container>
      </div>
    </ng-template>
  </div>

</div>